import * as React from 'react'
import ReactPaginate from 'react-paginate'
import { StyledPagination } from './_styled'

interface IPaginationProps {
  currentPage: number
  totalRecords: number
  customRecordsPerPage?: number
  showRecordsPerPage?: boolean
  onChange: (page: number) => void
}

const Next: React.FunctionComponent = () => {
  return (
    <span>
      <i className="fas fa-chevron-right"></i>
    </span>
  )
}

const Previous: React.FunctionComponent = () => {
  return (
    <span>
      <i className="fas fa-chevron-left"></i>
    </span>
  )
}

export const CustomPagination: React.FunctionComponent<IPaginationProps> = ({
  currentPage,
  totalRecords,
  customRecordsPerPage = 9,
  onChange,
}) => {
  const [pages, setPages] = React.useState<number>(1)

  React.useEffect(() => {
    if (totalRecords > 0) {
      const pages = Math.ceil(totalRecords / customRecordsPerPage)
      setPages(pages)

      if (currentPage > pages) {
        onChange(1)
      }
    } else {
      setPages(1)
    }
  }, [totalRecords, setPages, currentPage, onChange, customRecordsPerPage])

  const handlePaginationChange = React.useCallback(
    (page: { selected: number }) => {
      return onChange(page.selected + 1)
    },
    [onChange],
  )

  return totalRecords <= customRecordsPerPage ? null : (
    <StyledPagination>
      <div className="pagination-container">
        <ReactPaginate
          pageCount={pages}
          pageRangeDisplayed={10}
          marginPagesDisplayed={2}
          nextLabel={<Next />}
          previousLabel={<Previous />}
          onPageChange={handlePaginationChange}
        />
      </div>
    </StyledPagination>
  )
}
